export const modalWrapper: CSSFunction<{
  fullScreen: boolean;
}> = ({ cssProps, theme }) => {
  const { fullScreen = false } = cssProps;
  return {
    display: 'flex',
    width: fullScreen ? theme.modals.fullScreenWidth : '640px',
  };
};

export const videoIFrame: CSSFunction<{
  fullScreen: boolean;
}> = ({ cssProps }) => {
  const { fullScreen } = cssProps;
  return {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',

    '& iframe': {
      borderRadius: '8px',
      width: '100%',
      height: fullScreen ? '100%' : '360px',
    },
  };
};
